import { Link } from "react-router-dom";
import { SITE_ORIGIN, useJsonLd } from "../lib/seo";

// Visible breadcrumb trail + BreadcrumbList JSON-LD. items: [{ name, path }], last = current page.
export default function Breadcrumbs({ items, className = "" }) {
  useJsonLd("breadcrumbs", {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_ORIGIN}${it.path}`,
    })),
  });
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={className}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[11px] uppercase tracking-[0.14em] text-[#8A8A8A]">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-2">
              {last ? (
                <span aria-current="page" className="text-white/70 line-clamp-1" data-testid="breadcrumb-current">{it.name}</span>
              ) : (
                <Link to={it.path} className="hover:text-[#FF9F1C] transition-colors" data-testid={`breadcrumb-link-${i}`}>
                  {it.name}
                </Link>
              )}
              {!last && <span aria-hidden="true" className="text-white/30">›</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
